export const SERVICE_SHARE_NOW = 'share-now';
export const SERVICE_MB_RENT = 'mb-rent';
export const SERVICE_F2M_RENT = 'f2m-rent';
